import { gql } from '@apollo/client';

export const GET_SECTION_OWNER = gql`
  query GetSectionOwnerByStrategy(
    $uuid: ID!
    $strategyType: StrategySectionOwnerTypeEnum!
  ) {
    findSectionOwnerByStrategy(uuid: $uuid, strategyType: $strategyType) {
      uuid
      sectionOwnerfirstName
      sectionOwnerlastName
      email
      sectionRequired
    }
  }
`;

export const CREATE_SECTION_OWNER = gql`
  mutation CreateSectionOwner($data: CreateSectionOwnerInput!) {
    createSectionOwner(data: $data) {
      email
      sectionOwnerfirstName
      sectionOwnerlastName
      sectionRequired
    }
  }
`;

export const FETCH_SECTION_OWNERS = gql`
  query FindAllSectionOwners {
    findAllSectionOwners {
      email
      sectionOwnerfirstName
      sectionOwnerlastName
      sectionRequired
    }
  }
`;

export const FIND_SECTION_OWNER_BY_PLAN = gql`
  query FindSectionOwnerByPlan($uuid: ID!) {
    findSectionOwnerByPlan(uuid: $uuid) {
      uuid
      email
      sectionOwnerfirstName
      sectionOwnerlastName
      sectionRequired
    }
  }
`;

export const UPDATE_SECTION_OWNER = gql`
  mutation UpdateSectionOwner($data: UpdateSectionOwnerInput!) {
    updateSectionOwner(data: $data) {
      email
      sectionOwnerfirstName
      sectionOwnerlastName
      sectionRequired
      uuid
    }
  }
`;

export const FIND_SECTION_OWNER_BY_STRATEGY = gql`
  query FindSectionOwnerByStrategy(
    $strategyType: StrategySectionOwnerTypeEnum!
    $uuid: ID!
  ) {
    findSectionOwnerByStrategy(strategyType: $strategyType, uuid: $uuid) {
      uuid
      sectionRequired
      sectionOwnerfirstName
      sectionOwnerlastName
      email
    }
  }
`;
